import { Input, SimpleFormField } from '@invent/wl-ui-kit-next/ui';
import * as React from 'react';

/**
 * The code box of the page a mailed invitation opens — `/invitations/accept`: filled from the
 * link, and kept an ordinary editable box, so a link a mail client broke across two lines can be
 * mended by pasting the code. While it holds nothing it says why.
 */
export function LinkCodeField({
  label,
  value,
  onChange,
  disabled
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}) {
  const codeId = React.useId();

  return (
    <>
      <SimpleFormField label={label} htmlFor={codeId} required>
        <Input
          id={codeId}
          type="text"
          autoComplete="off"
          spellCheck={false}
          placeholder="From the link in the mail"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          disabled={disabled}
        />
      </SimpleFormField>
      {!value.trim() && (
        <p className="text-sm">
          The link has lost its code — a mail client may have broken it across two lines.
          Open it again from the mail, or paste the code here.
        </p>
      )}
    </>
  );
}
